const STORAGE_KEYS = {
  IMPERSONATED_USER: 'CapexImpersonatedUser',
} as const;

export { STORAGE_KEYS };
